module.exports = __webpack_public_path__ + "img/dhfesta_info_0401.5ad6ae06.jpg";